/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询当前账户的信息(实名制、手机绑定、微信)
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.AccountInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/setting/account/info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
